import React, { useRef } from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import { TextBody } from '../Typography';
import { Divider } from './Divider';
import { liStyles, selectableOptionStyles, ulStyles } from './styles';
const StyledUL = styled.ul `
  ${ulStyles}
`;
const StyledNav = styled.nav `
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
`;
const TextWrapper = styled.span `
  flex: 1;
`;
const StyledTextBody = styled(TextBody) `
  text-align: center;

  ${({ theme: { space } }) => `
    padding-bottom: ${space.xs};
  `}
`;
const StyledAnchor = styled.a `
  ${selectableOptionStyles}
`;
const StyledLI = styled.li `
  ${liStyles}
`;
export const ResultsPerPageBase = ({ options, selected, onChange, }) => {
    const labelId = useRef(uuidv4());
    return (React.createElement(StyledNav, { "aria-labelledby": labelId.current },
        React.createElement(StyledTextBody, { id: labelId.current, size: "xs", tag: "div", weight: "bold" }, "Results Per Page"),
        React.createElement(StyledUL, null, options.map((option, index) => (React.createElement(StyledLI, { "$wide": true, key: `${labelId.current}-${option}` },
            React.createElement(StyledAnchor, { "aria-current": option === selected, "$selected": option === selected, onClick: (e) => {
                    e.preventDefault();
                    onChange(option);
                }, href: "", "aria-labelledby": `${labelId.current}-${option} ${labelId.current}`, 
                // id is composition of label and option value so id is never
                // conflicting with other pagination components.
                id: `${labelId.current}-${option}`, "data-testid": `mui-pagination-results-per-page-${option}` },
                index !== 0 && (React.createElement(Divider, { "data-testid": `mui-pagination-results-per-page-${option}-left-divider` })),
                React.createElement(TextWrapper, null, option),
                index !== options.length - 1 && (React.createElement(Divider, { "data-testid": `mui-pagination-results-per-page-${option}-right-divider` })))))))));
};
//# sourceMappingURL=ResultsPerPageBase.js.map